import { datadogRum } from '@datadog/browser-rum';

import type { EventRequest } from 'types';

export const COLUMN_RENAME_TELEMETRY_EVENT = {
  saveFailed: 'column_rename_save_failed',
  saved: 'column_rename_saved',
} as const;

export type ColumnRenameTelemetryEvent = typeof COLUMN_RENAME_TELEMETRY_EVENT[keyof typeof COLUMN_RENAME_TELEMETRY_EVENT];

/** Records one column-rename RUM action, stamped with the event and company ids. */
export const trackColumnRename = (
  name: ColumnRenameTelemetryEvent,
  request: EventRequest | undefined,
  context: Record<string, unknown> = {}
): void => {
  datadogRum.addAction(name, {
    companyId: request?.company?.id ?? null,
    eventId: request?.id ?? null,
    ...context,
  });
};
